export var ExternalAccountingSyncFilter = /*#__PURE__*/ function(ExternalAccountingSyncFilter) {
    ExternalAccountingSyncFilter["Synced"] = "synced";
    ExternalAccountingSyncFilter["NotSynced"] = "notSynced";
    return ExternalAccountingSyncFilter;
}({});
